/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePortfolioDto
 */
export interface UpdatePortfolioDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePortfolioDto
     */
    iconName: UpdatePortfolioDtoIconNameEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePortfolioDto
     */
    colorName: UpdatePortfolioDtoColorNameEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePortfolioDto
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePortfolioDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePortfolioDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePortfolioDto
     */
    isRecalculating: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePortfolioDto
     */
    includedInSummary: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePortfolioDto
     */
    selected: boolean;
}

/**
* @export
* @enum {string}
*/
export enum UpdatePortfolioDtoIconNameEnum {
    Wallet = 'Wallet',
    WalletFilled = 'WalletFilled',
    Profits = 'Profits',
    ProfitsFilled = 'ProfitsFilled',
    Trades = 'Trades',
    TradesFilled = 'TradesFilled',
    Dividends = 'Dividends',
    DividendsFilled = 'DividendsFilled',
    AccountingDocument = 'AccountingDocument',
    Bell = 'Bell',
    BellFilled = 'BellFilled',
    ChartBar = 'ChartBar',
    HeartFilled = 'HeartFilled',
    Heart = 'Heart',
    CompoundInterest = 'CompoundInterest',
    ChartBarFilled = 'ChartBarFilled'
}/**
* @export
* @enum {string}
*/
export enum UpdatePortfolioDtoColorNameEnum {
    Blue = 'blue',
    BlueLight = 'blueLight',
    BlueDark = 'blueDark',
    Purple = 'purple',
    PurpleLight = 'purpleLight',
    PurpleDark = 'purpleDark',
    Green = 'green',
    GreenLight = 'greenLight',
    GreenDark = 'greenDark',
    Primary = 'primary',
    PrimaryLight = 'primaryLight',
    PrimaryDark = 'primaryDark',
    Secondary = 'secondary',
    SecondaryLight = 'secondaryLight',
    SecondaryDark = 'secondaryDark',
    Gray = 'gray',
    GrayLight = 'grayLight',
    GrayDark = 'grayDark',
    Orange = 'orange',
    OrangeLight = 'orangeLight',
    OrangeDark = 'orangeDark',
    Red = 'red',
    RedLight = 'redLight',
    RedDark = 'redDark',
    Pink = 'pink',
    PinkLight = 'pinkLight',
    PinkDark = 'pinkDark',
    Brown = 'brown',
    BrownLight = 'brownLight',
    BrownDark = 'brownDark',
    Yellow = 'yellow',
    YellowLight = 'yellowLight',
    YellowDark = 'yellowDark'
}

export function UpdatePortfolioDtoFromJSON(json: any): UpdatePortfolioDto {
    return UpdatePortfolioDtoFromJSONTyped(json, false);
}

export function UpdatePortfolioDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePortfolioDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iconName': json['iconName'],
        'colorName': json['colorName'],
        'currencyCode': json['currencyCode'],
        'id': json['id'],
        'name': json['name'],
        'isRecalculating': json['isRecalculating'],
        'includedInSummary': json['includedInSummary'],
        'selected': json['selected'],
    };
}

export function UpdatePortfolioDtoToJSON(value?: UpdatePortfolioDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iconName': value.iconName,
        'colorName': value.colorName,
        'currencyCode': value.currencyCode,
        'id': value.id,
        'name': value.name,
        'isRecalculating': value.isRecalculating,
        'includedInSummary': value.includedInSummary,
        'selected': value.selected,
    };
}

